"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProgressOverlay = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const react_1 = require("react");
const spinner_1 = require("../spinner");
const ProgressOverlayAncestorLoadingContext = (0, react_1.createContext)(false);
const ProgressOverlay = props => {
    const { isLoading, children, wrapperSx = {}, spinnerSx = {} } = props;
    const ancestorIsLoading = (0, react_1.useContext)(ProgressOverlayAncestorLoadingContext);
    const showSpinner = isLoading && !ancestorIsLoading;
    const hasActiveOverlay = ancestorIsLoading || isLoading;
    return ((0, jsx_runtime_1.jsx)(ProgressOverlayAncestorLoadingContext.Provider, { value: hasActiveOverlay, children: (0, jsx_runtime_1.jsxs)(material_1.Box, { sx: [
                {
                    position: "relative",
                    minHeight: 40,
                },
                ...(Array.isArray(wrapperSx) ? wrapperSx : [wrapperSx]),
            ], children: [children, showSpinner ? ((0, jsx_runtime_1.jsx)(material_1.Box, { sx: [
                        {
                            position: "absolute",
                            top: 0,
                            left: 0,
                            bottom: 0,
                            right: 0,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        },
                        ...(Array.isArray(spinnerSx) ? spinnerSx : [spinnerSx]),
                    ], children: (0, jsx_runtime_1.jsx)(spinner_1.Spinner, {}) })) : null] }) }));
};
exports.ProgressOverlay = ProgressOverlay;
//# sourceMappingURL=index.js.map